(() => {
  class BrandDirectory extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-brand-search]');
      this.filterButtons = Array.from(this.querySelectorAll('[data-brand-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-brand-card]'));
      this.count = this.querySelector('[data-brand-count]');
      this.empty = this.querySelector('[data-brand-empty]');
      this.activeLetter = 'all';

      this.availableLetters = new Set(this.cards.map((card) => card.dataset.brandLetter));
      this.filterButtons.forEach((button) => {
        const filter = button.dataset.brandFilter;
        if (filter !== 'all' && !this.availableLetters.has(filter)) button.disabled = true;
        button.addEventListener('click', () => this.selectLetter(filter));
      });

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          this.activeLetter = 'all';
          this.updateButtons();
          this.update();
        });
      }

      this.update();
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    }

    selectLetter(letter) {
      this.activeLetter = letter;
      if (this.searchInput) this.searchInput.value = '';
      this.updateButtons();
      this.update();
    }

    updateButtons() {
      this.filterButtons.forEach((button) => {
        const isActive = button.dataset.brandFilter === this.activeLetter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    update() {
      const query = this.normalize(this.searchInput?.value);
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const matchesSearch = !query || this.normalize(card.dataset.brandName).includes(query);
        const matchesLetter = this.activeLetter === 'all' || card.dataset.brandLetter === this.activeLetter;
        const visible = matchesSearch && matchesLetter;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const label = visibleCount === 1 ? this.dataset.countSingular : this.dataset.countPlural;
      if (this.count) this.count.textContent = `${visibleCount} ${label}`;
      if (this.empty) this.empty.hidden = visibleCount !== 0;
    }
  }

  if (!customElements.get('brand-directory')) customElements.define('brand-directory', BrandDirectory);
})();
